.CTAForm {
  display: grid;
  gap: var(--base-size-16);
  grid-template-columns: 2fr auto;
  align-items: flex-end;
}

.CTAForm > * {
  grid-column: span 2;
  width: 100%;
}

.CTAForm-input {
  order: 1;
}

.CTAForm-confirm {
  order: 2;
  grid-column: span 2;
}

.CTAForm-button {
  order: 4;
}

.CTAForm > *:not(.CTAForm-input, .CTAForm-button, .CTAForm-confirm) {
  order: 3;
  grid-column: span 2;
}

@media screen and (min-width: 48rem) {
  .CTAForm > * {
    grid-column: span 1;
  }

  .CTAForm-confirm {
    order: 3;
    grid-column: span 2;
  }

  .CTAForm-button {
    order: 2;
  }

  .CTAForm > *:not(.CTAForm-input, .CTAForm-button, .CTAForm-confirm) {
    order: 4;
  }
}
